export default {
  errors: {
    name: {
      NOT_UNIQUE_ERROR: 'مستوى التدخل بنفس الاسم موجود بالفعل في هذه المؤسسة'
    }
  }
}
